




















































































import {Vue,Component} from "vue-property-decorator";
import {getModule} from "vuex-module-decorators";
import {RealTimeInfoStore} from "@/store/RealTimeInfoStore";
import {RealTimeInfo} from "@/entity/RealTimeInfo";
import {RealTimeInfoReqDto} from "@/dto/RealTimeInfoReqDto";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {UserInfoEntityDto} from "@/dto/UserInfoEntityDto";
import RealTimeInfoReq from "@/dto/RealTimeInfoReq";
import { CompanyInfo } from "@/entity/CompanyInfo";
@Component({
  name: "RealTimeInfoList"
})
export default class RealTimeInfoList extends Vue{
  private tab = 'star'
  private rs = getModule(RealTimeInfoStore)
  private realInfos: Array<RealTimeInfo> = []
  su = SecurityUtils;
  current=6
  type = ''
  private realTimeInfoReq: RealTimeInfoReq=new RealTimeInfoReq();
  private page: RealTimeInfoReq=new RealTimeInfoReq();
  async created(){
    this.type='01'
    /*
    let demo1: UserInfoEntity = JSON.parse(localStorage.getItem("demo1") as string);
    if(demo1===undefined||demo1===null){
      await this.getRealInfo()
      demo1= JSON.parse(localStorage.getItem("demo1") as string);
    }
     */
    const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
    this.realTimeInfoReq.userName = this.su.getLoginUser().username;
    this.realTimeInfoReq.companyId = companyInfo.companyId as string;
    this.realTimeInfoReq.infoType='01';
    this.realTimeInfoReq.page=1;
    this.realTimeInfoReq.size=12;
    this.page = await RealTimeInfoReqDto.queryRealList(this.realTimeInfoReq);
    const newsList=this.page.content;
    newsList.sort((o1,o2)=>{
      return (o2.infoReadTime as number)-(o1.infoReadTime as number)
    })
    this.realInfos = newsList;
    localStorage.setItem("infoReal",JSON.stringify({"infoType":'01',"size":this.realInfos.length}));
    this.rs.setCurrentRealInfos(newsList);
  }
  async getRealInfo(){
    const userInfoEntity = new UserInfoEntity()
    userInfoEntity.userName = this.su.getLoginUser().username
    const identity = await UserInfoEntityDto.selectCompanyInfo(userInfoEntity)
    if(identity!==null && identity.length>0) {
      localStorage.setItem("demo1", JSON.stringify(identity[0]));
    }else{
      const useinfo: UserInfoEntity=new UserInfoEntity();
      useinfo.userName=this.su.getLoginUser().username;
      localStorage.setItem("demo1", JSON.stringify(useinfo));
    }
  }
  refresh() {
    setTimeout(() => {
      location.reload();
      // this.$router.push({name:'refresh'})
    }, 1000)
  }
  fanhui(){
    this.$router.push({name:'KeShangSelect'})
  }
  goToDetail(realInfo: RealTimeInfo){
    this.$router.push( '/RealTimeInfoView/'+realInfo.id)
  }

  async existIdentity(){
    const userInfoEntity = new UserInfoEntity()
    userInfoEntity.userName = this.su.getLoginUser().username
    const identity = await UserInfoEntityDto.selectCompanyInfo(userInfoEntity)
    if(identity!=null&&identity.length>0){
      return true;
    }
    return false;
  }
  async handleRealInfo(newVal: string,oldVal: string){
    this.realInfos=[]
    const type=this.realTimeInfoReq.getRealInfoType(newVal);
    this.type=type as string
    console.log(type);
    if(type!=undefined){
      this.realTimeInfoReq.infoType=type;
      this.realTimeInfoReq.page=1;
      this.realTimeInfoReq.size=12;
      // const demo1: UserInfoEntity=JSON.parse(localStorage.getItem('demo1') as string);
      const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
      if(await this.existIdentity()){
        this.realTimeInfoReq.userName=this.su.getLoginUser().username;
        this.realTimeInfoReq.companyId=companyInfo.companyId;
      }else{
        this.realTimeInfoReq.userName=this.su.getLoginUser().username;
      }
      this.page=await RealTimeInfoReqDto.queryRealList(this.realTimeInfoReq);
      const newsList=this.page.content;
      newsList.sort((o1,o2)=>{
        return (o2.infoReadTime as number)-(o1.infoReadTime as number)
      })
      this.realInfos=newsList;
      await localStorage.setItem("infoReal",JSON.stringify({"infoType":type,"size":this.realInfos.length}));
      await getModule(RealTimeInfoStore).setCurrentRealInfos(newsList);
    }
  }

  async handlePage(value: string){
    console.log(value);
    this.realTimeInfoReq.page=Number(value);
    this.page=await RealTimeInfoReqDto.queryRealList(this.realTimeInfoReq);
    const newsList=this.page.content;
    newsList.sort((o1,o2)=>{
      return (o2.infoReadTime as number)-(o1.infoReadTime as number)
    })
    this.realInfos=newsList;
    await getModule(RealTimeInfoStore).setCurrentRealInfos(newsList);
  }
  async onLoad (index: number, done: Function) {
    console.log(index);
    if(index>1) {
     setTimeout(async () => {
       this.realTimeInfoReq.page=this.realTimeInfoReq.page+1;
       this.page=await RealTimeInfoReqDto.queryRealList(this.realTimeInfoReq);
       console.log(index);
       if(this.page.content.length>0) {
         this.realInfos.push(...this.page.content)
         localStorage.setItem("infoReal",JSON.stringify({"infoType":this.type,"size":this.realInfos.length}));
         done();
       }else {
         done(true)
       }
      }, 1000)
    }else {
      // setTimeout(()=>{
        done();
      // },1000)
    }
  }
}
